// Flowing layered topographic wave background — white → light blue → deep navy.
// Rendered as a fixed full-viewport image at low opacity so site content
// remains comfortably legible on every section.

const BG_URL =
    "https://customer-assets.emergentagent.com/job_bookkeeping-pro-30/artifacts/qhevtfik_image.png";

export default function PolyBackground() {
    return (
        <div
            aria-hidden="true"
            className="fixed inset-0 -z-10 pointer-events-none"
            style={{
                backgroundImage: `url("${BG_URL}")`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center center",
                backgroundSize: "cover",
                backgroundColor: "#FAF9F6",
                opacity: 0.55,
            }}
        />
    );
}
